import { DatePipe, DecimalPipe } from "@angular/common";
import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateDirective, TranslatePipe } from "@ngx-translate/core";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IOperation } from "~app/features/planera/model/IOperation";
import { FordelningPipe } from "../../../../common/pipes/fordelning.pipe";
import { PlaneringsstatusIndicatorComponent } from "../../planeringsstatus-indicator/planeringsstatus-indicator.component";
import { ArbetsorderService } from "../../services/arbetsorder.service";

@Component({
    selector: "rask-planera-ao-grot-popup",
    templateUrl: "./planera-ao-grot-popup.component.html",
    styleUrls: ["./planera-ao-grot-popup.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterLink,
        PlaneringsstatusIndicatorComponent,
        TranslateDirective,
        DecimalPipe,
        DatePipe,
        TranslatePipe,
        FordelningPipe
    ]
})
export class PlaneraAoGrotPopupComponent implements OnInit {
    arbetsorder: IArbetsorderDetail;
    operationer: IOperation[];
    showAndelData: boolean;

    private readonly arbetsorderService = inject(ArbetsorderService);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("data")
    set data(value: any) {
        this.arbetsorder = value;
    }

    ngOnInit(): void {
        this.showAndelData = this.arbetsorderService.hasAtgardAndelData(this.arbetsorder);
        this.operationer = this.arbetsorder.operationer.filter(o => o.operationstyp === "Skotning");
    }
}
